/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './post-op-recovery-record.reducer';

export const PostOPRecoveryRecordDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const postOPRecoveryRecordEntity = useAppSelector(state => state.postOPRecoveryRecord.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="postOPRecoveryRecordDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.detail.title">PostOPRecoveryRecord</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.id">Id</Translate>
            </span>
          </dt>
          <dd>{postOPRecoveryRecordEntity.id}</dd>
          <dt>
            <span id="time">
              <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.time">Time</Translate>
            </span>
          </dt>
          <dd>{postOPRecoveryRecordEntity.time}</dd>
          <dt>
            <span id="painScore">
              <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.painScore">Pain Score</Translate>
            </span>
          </dt>
          <dd>{postOPRecoveryRecordEntity.painScore}</dd>
          <dt>
            <span id="sedationScore">
              <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.sedationScore">Sedation Score</Translate>
            </span>
          </dt>
          <dd>{postOPRecoveryRecordEntity.sedationScore}</dd>
          <dt>
            <span id="intakeType">
              <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.intakeType">Intake Type</Translate>
            </span>
          </dt>
          <dd>{postOPRecoveryRecordEntity.intakeType}</dd>
          <dt>
            <span id="intakeAmount">
              <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.intakeAmount">Intake Amount</Translate>
            </span>
          </dt>
          <dd>{postOPRecoveryRecordEntity.intakeAmount}</dd>
          <dt>
            <span id="outputType">
              <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.outputType">Output Type</Translate>
            </span>
          </dt>
          <dd>{postOPRecoveryRecordEntity.outputType}</dd>
          <dt>
            <span id="outputAmount">
              <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.outputAmount">Output Amount</Translate>
            </span>
          </dt>
          <dd>{postOPRecoveryRecordEntity.outputAmount}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.active">Active</Translate>
            </span>
          </dt>
          <dd>{postOPRecoveryRecordEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{postOPRecoveryRecordEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{postOPRecoveryRecordEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{postOPRecoveryRecordEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{postOPRecoveryRecordEntity.timestampentry}</dd>
          <dt>
            <span id="sedationScoreValue">
              <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.sedationScoreValue">Sedation Score Value</Translate>
            </span>
          </dt>
          <dd>{postOPRecoveryRecordEntity.sedationScoreValue}</dd>
          <dt>
            <span id="painScale">
              <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.painScale">Pain Scale</Translate>
            </span>
          </dt>
          <dd>{postOPRecoveryRecordEntity.painScale}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.surgery">Surgery</Translate>
          </dt>
          <dd>{postOPRecoveryRecordEntity.surgery ? postOPRecoveryRecordEntity.surgery.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.nurse">Nurse</Translate>
          </dt>
          <dd>{postOPRecoveryRecordEntity.nurse ? postOPRecoveryRecordEntity.nurse.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.vitals">Vitals</Translate>
          </dt>
          <dd>{postOPRecoveryRecordEntity.vitals ? postOPRecoveryRecordEntity.vitals.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.aldreteScore">Aldrete Score</Translate>
          </dt>
          <dd>{postOPRecoveryRecordEntity.aldreteScore ? postOPRecoveryRecordEntity.aldreteScore.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.behaviouralPainScore">Behavioural Pain Score</Translate>
          </dt>
          <dd>{postOPRecoveryRecordEntity.behaviouralPainScore ? postOPRecoveryRecordEntity.behaviouralPainScore.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.flaccScore">Flacc Score</Translate>
          </dt>
          <dd>{postOPRecoveryRecordEntity.flaccScore ? postOPRecoveryRecordEntity.flaccScore.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.nipsScore">Nips Score</Translate>
          </dt>
          <dd>{postOPRecoveryRecordEntity.nipsScore ? postOPRecoveryRecordEntity.nipsScore.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.wongBakersPainScore">Wong Bakers Pain Score</Translate>
          </dt>
          <dd>{postOPRecoveryRecordEntity.wongBakersPainScore ? postOPRecoveryRecordEntity.wongBakersPainScore.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.postOpRecovery">Post Op Recovery</Translate>
          </dt>
          <dd>{postOPRecoveryRecordEntity.postOpRecovery ? postOPRecoveryRecordEntity.postOpRecovery.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/post-op-recovery-record" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/post-op-recovery-record/${postOPRecoveryRecordEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PostOPRecoveryRecordDetail;
